import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';

import LiveTvProgressBar from '@smart-tv/components/live-tv-progress-bar/live-tv-progress-bar';
import ProgressBar from '@smart-tv/components/progress-bar/progress-bar';
import Typography from '@smart-tv/components/typography/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import isWithinInterval from '@smart-tv/utils/date/is-within-interval';

import { rootStore } from '../_stores/store-root';

export const SheetProgressBar = observer(() => {
  const { sheet } = rootStore.sheetStore;

  if (!sheet.progressBar) return null;

  const startTime = sheet?.infoBlock?.startTime ?? 0;
  const endTime = startTime + (sheet?.infoBlock?.duration ?? 0);
  const isFlowTvLive = isWithinInterval(Date.now(), { start: startTime * 1000, end: endTime * 1000 });

  return (
    <div className={styles['progress']}>
      {isFlowTvLive ? (
        <LiveTvProgressBar
          className={styles['progress__bar']}
          height={8}
          startTime={new Date(sheet.progressBar.start * 1000)}
          endTime={new Date(sheet.progressBar.end * 1000)}
          data-testid={testIds.programsheet.info.progressBarLive}
        />
      ) : (
        <ProgressBar
          className={styles['progress__bar']}
          height={8}
          value={sheet.progressBar.percentage}
          data-testid={testIds.programsheet.info.progressBar}
        />
      )}
      <div className={styles['progress__duration']}>
        <Typography variant="caption" component="div">
          {sheet.progressBar.label}
        </Typography>
      </div>
    </div>
  );
});

export default SheetProgressBar;
